import * as React from 'react';

import { Spinner } from './components/ui/spinner.js';

export function DimeSpinner({ ...props }: Readonly<React.ComponentProps<typeof Spinner>>) {
  return <Spinner {...props} />;
}
